export default __webpack_public_path__ + "static/media/5.6948e0dd.jpg";